import { useMemo } from 'react';

import { useServerStorage } from 'utils/useServerStorage';

type CardId = 'elevio' | 'knowledge' | (string & {});

export const useConversationSidebarSettings = (): {
  readonly cardOpenState: Readonly<Record<CardId, boolean>>;
  readonly isSidebarOpen: boolean;
  readonly setCardOpen: (key: CardId, open: boolean) => void;
  readonly setSidebarOpen: (open: boolean) => void;
  readonly toggleSidebar: () => void;
} => {
  const storage = useServerStorage('user');

  return useMemo(() => {
    const cardOpenState = storage.data.conversation?.sidebarCardOpenState ?? {};
    const isSidebarOpen = storage.data.conversation?.isSidebarOpen ?? false;

    const setCardOpen = (key: CardId, open: boolean) => {
      storage.set({
        conversation: (draft) => {
          draft.sidebarCardOpenState = {
            ...draft.sidebarCardOpenState,
            [key]: open,
          };
        },
      });
    };

    const setSidebarOpen = (open: boolean) => {
      storage.set({
        conversation: (draft) => {
          draft.isSidebarOpen = open;
        },
      });
    };

    const toggleSidebar = () => {
      setSidebarOpen(!isSidebarOpen);
    };

    return {
      cardOpenState,
      isSidebarOpen,
      setCardOpen,
      setSidebarOpen,
      toggleSidebar,
    };
  }, [storage]);
};
